import { SET_BULK_UPDATE_FIELDS } from '@/store/mutation-types'
import BulkUpdateService from '@/services/BulkUpdateService'

export default {
  state: {
    fields: Object,
    controlValidationsField: Boolean,
    controlActionsField: Boolean,
  },
  mutations: {
    [SET_BULK_UPDATE_FIELDS](state, response) {
      state.fields = response.listViewFields
      state.controlValidationsField = response.controlValidationsField
      state.controlActionsField = response.controlActionsField
    },
  },
  actions: {
    async fetchAllFieldDetails({ commit, dispatch }, payload) {
      try {
        const response = (
          await BulkUpdateService.getBulkUpdateFields(
            payload.rootType,
            payload.fieldIds,
            payload.bpdId,
            payload.listBpdId,
          )
        ).data
        commit(SET_BULK_UPDATE_FIELDS, response)
      } catch (error) {
        const message = error.response ? error.response.data : error
        const notification = { type: 'error', message }
        dispatch('Notification/add', notification, { root: true })
      } finally {
        window.parent.postMessage(
          {
            status: 'vue-loaded',
          },
          window.location.origin,
        )
      }
    },
  },
}
